<template>
    <div>
        <b-container fluid class="px-0 image-and-text-portfolio" :style="{ backgroundColor: imageAndTextContent.bgColor }" :class="[imageAndTextContent.bgImageClass]">
            <b-row>
                <b-col lg="6" 
                class="px-0" 
                :class="[{ 
                    'order-2' : !imageAndTextContent.imgOnLeftSide,
                    'order-1' : imageAndTextContent.imgOnLeftSide 
                    }]">
                    <img 
                        v-if="imageAndTextContent.img"
                        :src="imageAndTextContent.img"
                        class="w-100 object-fit-cover d-block"
                        :alt="imageAndTextContent.alt"
                        :class="{'px-80 py-80' : imageAndTextContent.imgPadding}"
                    >
                    <video 
                        v-else
                        :src="imageAndTextContent.video"
                        autoplay
                        loop
                        muted
                        playsinline
                        class="w-100 object-fit-cover d-block"></video>
                </b-col>
                <b-col lg="6" 
                class="px-0"
                :class="[{ 
                    'order-2' : imageAndTextContent.imgOnLeftSide, 
                    'order-1' : !imageAndTextContent.imgOnLeftSide,
                }, imageAndTextContent.otherSideBgClass]" :style="imageAndTextContent.bgColor">
                
                    <div class="py-5 py-lg-0 pt-lg-0 text-white d-lg-flex justify-content-center flex-column h-100 w-100 max-w-400 mx-auto px-5 px-lg-0"
                    >
                        <div 
                            class="slick-copy" 
                            :style="{ color: imageAndTextContent.textColor }">
                            <p class="gotham-bold">
                                {{ imageAndTextContent.heading }}
                            </p>
                            <p class="gotham-book" v-html="imageAndTextContent.desc">
                            </p>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    props: ['imageAndTextContent'],
    data() {
        return {
            
        }
    },
    beforeMount() {

    },
}
</script>

<style lang="scss" >

.image-and-text-portfolio {
    .slick-dotted.slick-imageAndTextContentr {
        margin-bottom: -6px;
    }  
}

</style>